import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import AdminDashboard from "../pages/Admin/AdminDashboard";
import Reports from "../pages/Admin/Reports";
import AdminEntityPage from "../pages/Admin/AdminEntityPage";
import AdminTransporterPage from "../pages/Admin/AdminTransporterPage";
import AdminVehiclePage from "../pages/Admin/AdminVehiclePage";
import ConsignorDashboard from "../pages/consignor/ConsignorDashboard";
import CreateConsignment from "../pages/consignor/CreateConsignment";
import MyConsignments from "../pages/consignor/MyConsignments";
import TransporterDashboard from "../pages/Transporter/TransporterDashboard";
import ManageLoads from "../pages/Transporter/ManageLoads";
import Charges from "../pages/Transporter/Charges";
import Fleet from "../pages/Transporter/Fleet";
import ReceiverDashboard from "../pages/Receiver/ReceiverDashboard";
import DeliveryHistory from "../pages/Receiver/DeliveryHistory";
import TrackShipment from "../pages/Receiver/TrackShipment";
import DriverApp from "../pages/Driver/DriverApp";
import CurrentTrip from "../pages/Driver/CurrentTrip";
import UpdateStatus from "../pages/Driver/UpdateStatus";
import AddTransporter from "../pages/Transporter/AddTransporter";
import { EditConsignment } from "../pages/Admin/EditConsigment";
import AddCompany from "../pages/Company/AddCompany";
import Company from "../pages/Company/Company";
import User from "../pages/UserList/User";
import { AddConsignment } from "../pages/Admin/AddConsignment";
import Settlement from "../pages/Settlement/Settlement";
import SettlementRecord from "../pages/Settlement/SettlementRecords";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function AllRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />

      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/admin" replace />} />

        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/allusers" element={<User/>} />
        
        <Route path="/admin/users" element={<Navigate to="/admin/users/list" replace />} />
        <Route path="/admin/add-user" element={<Navigate to="/admin/users/add" replace />} />
        <Route path="/admin/users/add" element={<AdminEntityPage role="user" mode="add" title="User" />} />
        <Route path="/admin/settlement" element={<Settlement/>} />
        <Route path="/admin/settlement/:id" element={<Settlement/>} />
        <Route path="/admin/Settlementrecord" element={<SettlementRecord/>} />
        <Route path="/admin/Settlementrecord/:entityKey" element={<SettlementRecord/>} />
        <Route path="/admin/users/list" element={<AdminEntityPage role="user" mode="list" title="User" />} />
        <Route path="/admin/users/edit/:id" element={<AdminEntityPage role="user" mode="edit" title="User" />} />
        <Route path="/admin/company" element={<Company/>} />
        <Route path="/admin/add/consignments" element={<AddConsignment/>} />
        <Route path="/admin/edit/consignments/:id" element={<EditConsignment/>} />
        <Route path="/admin/add-company" element={<AddCompany/>} />
        <Route path="/admin/consignors" element={<Navigate to="/admin/consignors/list" replace />} />
        <Route path="/admin/add-consignor" element={<Navigate to="/admin/consignors/add" replace />} />
        <Route path="/admin/consignors/add" element={<AdminEntityPage role="consignor" mode="add" title="Consignor" />} />
        <Route path="/admin/consignors/list" element={<AdminEntityPage role="consignor" mode="list" title="Consignor" />} />
        <Route path="/admin/consignors/edit/:id" element={<AdminEntityPage role="consignor" mode="edit" title="Consignor" />} />

        <Route path="/admin/consignees/add" element={<AdminEntityPage role="consignee" mode="add" title="consignee" />} />
        <Route path="/admin/consignees/list" element={<AdminEntityPage role="consignee" mode="list" title="consignee" />} />
        <Route path="/admin/consignees/edit/:id" element={<AdminEntityPage role="consignee" mode="edit" title="consignee" />} />



        <Route path="/admin/receivers" element={<Navigate to="/admin/receivers/list" replace />} />
        <Route path="/admin/add-receiver" element={<Navigate to="/admin/receivers/add" replace />} />
        <Route path="/admin/receivers/add" element={<AdminEntityPage role="receiver" mode="add" title="Receiver" />} />
        <Route path="/admin/receivers/list" element={<AdminEntityPage role="receiver" mode="list" title="Receiver" />} />
        <Route path="/admin/receivers/edit/:id" element={<AdminEntityPage role="receiver" mode="edit" title="Receiver" />} />
        <Route path="/admin/transporters" element={<Navigate to="/admin/transporters/list" replace />} />
        <Route path="/admin/add-transporter" element={<Navigate to="/admin/transporters/add" replace />} />
        {/* <Route path="/admin/transporters/add" element={<AdminTransporterPage mode="add" />} /> */}
        <Route path="/admin/transporters/add" element={<AddTransporter />} />
        <Route path="/admin/transporters/list" element={<AdminTransporterPage mode="list" />} />
        <Route path="/admin/transporters/edit/:id" element={<AdminTransporterPage mode="edit" />} />
        <Route path="/admin/drivers" element={<Navigate to="/admin/drivers/list" replace />} />
        <Route path="/admin/add-driver" element={<Navigate to="/admin/drivers/add" replace />} />
        <Route path="/admin/drivers/add" element={<AdminEntityPage role="driver" mode="add" title="Driver" />} />
        <Route path="/admin/drivers/list" element={<AdminEntityPage role="driver" mode="list" title="Driver" />} />
        <Route path="/admin/drivers/edit/:id" element={<AdminEntityPage role="driver" mode="edit" title="Driver" />} />
        <Route path="/admin/vehicles" element={<Navigate to="/admin/vehicles/list" replace />} />
        <Route path="/admin/add-vehicle" element={<Navigate to="/admin/vehicles/add" replace />} />
        <Route path="/admin/vehicles/add" element={<AdminVehiclePage mode="add" />} />
        <Route path="/admin/vehicles/list" element={<AdminVehiclePage mode="list" />} />
        <Route path="/admin/vehicles/edit/:id" element={<AdminVehiclePage mode="edit" />} />
        <Route path="/admin/consignments" element={<Reports />} />
        <Route path="/admin/reports" element={<Reports />} />
        <Route path="/admin/settings" element={<Navigate to="/admin/users/list" replace />} />

        <Route path="/admin/consignor/dashboard" element={<ConsignorDashboard />} />
        <Route path="/consignor/create" element={<CreateConsignment />} />
        <Route path="/consignor/consignments" element={<MyConsignments />} />
        <Route path="/consignor/track" element={<TrackShipment />} />
        <Route path="/consignor/reports" element={<MyConsignments />} />

        <Route path="/transporter" element={<TransporterDashboard />} />
        <Route path="/transporter/loads" element={<ManageLoads />} />
        <Route path="/transporter/drivers" element={<Fleet />} />
        <Route path="/transporter/fleet" element={<Fleet />} />
        <Route path="/transporter/charges" element={<Charges />} />
        <Route path="/transporter/reports" element={<TransporterDashboard />} />

        <Route path="/receiver" element={<ReceiverDashboard />} />
        <Route path="/receiver/incoming" element={<ReceiverDashboard />} />
        <Route path="/receiver/track" element={<TrackShipment />} />
        <Route path="/receiver/history" element={<DeliveryHistory />} />

        <Route path="/driver" element={<DriverApp />} />
        <Route path="/driver/trip" element={<CurrentTrip />} />
        <Route path="/driver/history" element={<UpdateStatus />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default AllRoutes;
